// extracted by mini-css-extract-plugin
export default {"column":"KanbanColumn_column__EkTfG","droppableBox":"KanbanColumn_droppableBox__QQUsJ","availableDroppableBox":"KanbanColumn_availableDroppableBox__lriL9"};